import { render, staticRenderFns } from "./ColumnTable.vue?vue&type=template&id=67e73726&"
import script from "./ColumnTable.vue?vue&type=script&lang=js&"
export * from "./ColumnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports